
import React from 'react';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { getTheme } from 'office-ui-fabric-react/lib/Styling';

import WebHonitbaLogo from '../../assets/webHonitba.png';

import ArticleLink from '../articles/ArticleLink';
import TileContent from './TileContent';

const classNames = mergeStyleSets({
    logo: {
        padding: 16,
    },
    logoWithLink: {
        padding: 16,
        ':hover': {
            backgroundColor: '#dddddd'
        },
        a: {
            color: getTheme().semanticColors.link,
            textDecoration: 'none',
        },
        'a:hover': {
            color: getTheme().semanticColors.linkHovered,
            textDecoration: 'underline',
        }
    }
});

const Logo = ({description}) => {
    return (
        <Stack>
            <Stack.Item align="center">
                <img src={WebHonitbaLogo} alt="webHONITBA" />
            </Stack.Item>
            <Stack.Item align="center">
                <div>{description}</div>
            </Stack.Item>
        </Stack>
    );
}

const AppLogo = ({activated, token}) => {

    if (activated && token) {
        const appUrl = `/client/webhonitba/honitba.php?sid=${token}`;
        return (
            <div className={classNames.logoWithLink}>
                <a href={appUrl} >
                    <Logo description="Spustit aplikaci" />
                </a>
            </div>
        );
    } else {
        return (
            <div className={classNames.logo}>
                <Logo description="Pro spuštění aplikace je potřeba se přihlásit" />
            </div>
        );
    }
}

const TileWebHonitba = ({activated, token}) => {
    return (
        <TileContent title="webHONITBA">
            <Stack tokens={{childrenGap: 16}}>
                <Stack.Item>Aplikace pro kompletní zpracování podkladů pro uznání honitby.</Stack.Item>
                <Stack.Item align="center">
                    <AppLogo
                        activated={activated}
                        token={token}
                    />
                </Stack.Item>
                <Stack.Item>
                    <Stack>
                        <Stack.Item>
                            <ArticleLink name="wh_vyhody" title="Výhody aplikace webHONITBA" />
                        </Stack.Item>
                        <Stack.Item>
                            <ArticleLink name="wh_navod" title="Návod k aplikaci webHONITBA" />
                        </Stack.Item>
                        <Stack.Item>
                            <ArticleLink name="wh_cenik" title="Ceník aplikace webHONITBA" />
                        </Stack.Item>
                    </Stack>
                </Stack.Item>
            </Stack>
        </TileContent>
    );
}

export default TileWebHonitba;
